import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { ConfiguratorComponent } from '../Forms/types';
import { TextareaAutosize } from '@material-ui/core';
import { useStyles } from './styles';
import { selectOptionSync, selectSystemParameterOptionSync } from '../../Reducers/Configurator/Actions';
import { t } from '@configuratorware/configurator-frontendgui/Framework/i18n';

interface OptionCommentProps {
  component: ConfiguratorComponent;
  variant?: 'configuration';
}

const OptionComment: React.FC<OptionCommentProps> = (props) => {
  const { component, variant } = props;
  const classes = useStyles();
  const dispatch = useDispatch();
  const selectedOption = component.selectedOption || component.selectedOptions?.[0];
  const inputTextValue = selectedOption?.inputText;

  const [inputText, setInputText] = useState(inputTextValue);

  useEffect(() => {
    if (inputText !== inputTextValue) {
      setInputText(inputTextValue);
    }
  }, [inputTextValue]);

  const handleBlur = () => {
    dispatch(
      variant === 'configuration'
        ? selectOptionSync(selectedOption, component, inputText)
        : selectSystemParameterOptionSync(component, selectedOption, inputText)
    );
  };

  const handleChange = (e) => setInputText(e.target.value);

  return selectedOption?.hasTextinput ? (
    <TextareaAutosize
      value={inputText || ''}
      onChange={handleChange}
      minRows={4}
      maxLength={80}
      onBlur={handleBlur}
      className={variant === 'configuration' ? classes.textAreaConfiguration : classes.textArea}
      placeholder={t('optionComment.placeholder')}
    />
  ) : null;
};

export default OptionComment;
